import { Directive, AfterViewInit, ElementRef, Input, Optional } from '@angular/core';

@Directive({ selector: '[gmtHighlight]' })
export class SearchHighlightDirective implements AfterViewInit {
  @Input('gmtHighlight') value: any;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const text = this.el.nativeElement.textContent == null ? '' : String(this.el.nativeElement.textContent);
    const safe = this.escapeHtml(text);
    this.el.nativeElement.innerHTML = this.highlightTerms(safe, this.extractTerms(this.value));
  }

  /** Extracts unique highlighted terms from OS highlight fragments. */
  extractTerms(highlight: { [field: string]: string[] }) {
    const terms: string[] = [];
    Object.keys(highlight).forEach(field => {
      (highlight[field] || []).forEach((fragment: string) => {
        const re = /<mark>(.*?)<\/mark>/gi;
        let match: RegExpExecArray | null;
        while ((match = re.exec(fragment)) !== null) {
          if (match[1] && terms.indexOf(match[1]) === -1) {
            terms.push(match[1]);
          }
        }
      });
    });
    return terms;
  }

  /** Escapes HTML special characters to prevent XSS. */
  escapeHtml(str: string): string {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /** Wraps all occurrences of `terms` in `<mark>` tags (case-insensitive). */
  highlightTerms(text: string, terms: string[]): string {
    if (!terms.length) { return text; }
    // Sort longest first so e.g. "1000/1" takes precedence over "1000" or "1"
    const sorted = terms.slice().sort((a, b) => b.length - a.length);
    const pattern = sorted.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
    return text.replace(new RegExp(pattern, 'gi'), m => '<mark>' + m + '</mark>');
  }

}
